import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import type { IWidgetProps } from 'widgets/FilterEditor/types/types'
import styles from './styles.module.scss'

export const WidgetLocal = observer(({ filterItem }: IWidgetProps) => {
  const filterValues = Array.isArray(filterItem.payload.value)
    ? filterItem.payload.value
    : filterItem.payload.value !== null
    ? [filterItem.payload.value as string]
    : []

  const triggerText = () => {
    const key = filterValues[0]

    if (key === 'no_replies') return 'No replies'

    return ''
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const operator = filterItem?._operators?._operator

  return (
    <>
      <Typography
        variant={'body-md-regular'}
        color={'var(--content-primary-tertiary)'}
        ariaLabel={'WidgetLocal'}
        className={styles.operator}
      >
        {operator}
      </Typography>
      <Typography
        variant={'body-md-regular'}
        color={'var(--content-primary-tertiary)'}
        ariaLabel={'WidgetLocal'}
      >
        {triggerText()}
      </Typography>
    </>
  )
})
